// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__3iy4-","navbarHidden":"Menu_navbarHidden__1_Db5"};